import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import { BrokeFlexMessageService } from '../services'
import { BrokeFlexMessageCampaignModel } from '../../types'

function useQueryGetBrokeFlexMessageCampaign(
	id: string,
	props?: UseBaseQueryOptions<BrokeFlexMessageCampaignModel>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetBrokeFlexMessageCampaign, id],
		queryFn: () => BrokeFlexMessageService.getCampaign(id),
		enabled: !!id,
		...props,
	})
}

export default useQueryGetBrokeFlexMessageCampaign
